module.exports = __webpack_public_path__ + "img/ezwrite6_education_bg_gradient.0d8519fd.svg";